import { useMemo } from 'react'
import { ArticleResult } from "interface/article"
import {
  Stack, Box, Alert,
  List, ListItem, ListItemProps, ListItemButton, 
  Typography
} from "@mui/material"

import { formatJournalDate } from 'features/article/util'
import { ArticleSourceChip } from 'features/article/components/articleSourceChip'
import { PublicationTypeChips } from 'features/article/components/publicationTypeChips'
import { ArticleWordsChips } from 'features/article/components/articleWordsChips'

type ArticleListRecordProps = {
  article: ArticleResult
  selected: boolean
  onSelChangeArticle: (article: ArticleResult) => void
} & ListItemProps
export const ArticleListRecord = ({
  article,
  selected,
  onSelChangeArticle,
  ...others
}: ArticleListRecordProps) => {
  const journalDate = useMemo(
    () => formatJournalDate(article),
    [article]
  )
  return (
    <ListItem disablePadding {...others}>
      <ListItemButton
        onClick={() => onSelChangeArticle(article)}
        selected={selected}
        sx={{
          padding: 1,
          borderBottom: 1,
          borderColor: 'divider'
        }}
      >
        <Stack
          direction='row'
          justifyContent="space-between"
          flexWrap="wrap"
          spacing={0.5}
          useFlexGap
          width='100%'
        >
          {article.titleJpn === null ? (
            article.title ? (
              <Typography variant='body2' component='span' translate='yes'>{article.title}</Typography>
            ) : (
              <Typography variant='body2' color='text.secondary' component='span'>(No title)</Typography>
            )
          ) : article.titleJpn !== article.title ? (
            <>
              <Typography variant='body2' component='span'>{article.titleJpn}</Typography>
              <Typography variant='caption' color='text.secondary' component='span'>{article.title}</Typography>
            </>
          ) : (
            <Typography variant='body2' component='span'>{article.titleJpn}</Typography>
          )}
          <Stack
            direction='row'
            flexGrow={1}
            spacing={0.5}
            alignItems='center'
            flexWrap='wrap'
            useFlexGap
          >
            <ArticleSourceChip source={article.source} size='small'/>
            <PublicationTypeChips publicationTypes={article.publicationType} size='small'/>
            <ArticleWordsChips words={article.words} size='small'/>
          </Stack>
          {journalDate && <Typography variant='body2' component='span'>{journalDate}</Typography>}
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}

type ArticleListProps = {
  articles: ArticleResult[]
  selectedArticleId: number | null
  onSelChangeArticle: (articleId: number) => void
}
export const ArticleList = ({
  articles,
  selectedArticleId,
  onSelChangeArticle
}: ArticleListProps) => {
  return articles.length === 0 ? (
    <Box padding={1}><Alert severity="info">対象が見つかりません.</Alert></Box>
  ) : (
    <List disablePadding>
      {articles.map(record =>
        <ArticleListRecord
          key={record.articleId}
          article={record}
          selected={record.articleId === selectedArticleId}
          onSelChangeArticle={article => onSelChangeArticle(article.articleId)} />
      ) }
    </List>
  )
}

